import { render, staticRenderFns } from "./Faxes.vue?vue&type=template&id=33d7a806&"
import script from "./Faxes.vue?vue&type=script&lang=js&"
export * from "./Faxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports